import React, { useEffect, useState } from "react";
import "./ConstructionInterior.css";
import int3 from "../../assets/int3.jpg";
import int4 from "../../assets/int4.jpg";
import int5 from "../../assets/int5.jpg";
import int6 from "../../assets/int6.jpg";
import int7 from "../../assets/int7.jpeg";
import int8 from "../../assets/int8.jpeg";
import int9 from "../../assets/int9.jpeg";
import int10 from "../../assets/int10.jpeg";
import int11 from "../../assets/int11.jpeg";
import int12 from "../../assets/int12.jpeg";
import int13 from "../../assets/int13.jpeg";
import int14 from "../../assets/int14.jpeg";
import int15 from "../../assets/int15.png";
import int16 from "../../assets/int16.png";
import int17 from "../../assets/int17.png";
import int18 from "../../assets/int18.jpeg";
import int19 from "../../assets/int19.jpeg";
import int20 from "../../assets/int20.jpeg";
import int21 from "../../assets/int21.png";
import int22 from "../../assets/int22.jpeg";
import int23 from "../../assets/int23.jpeg";
import int24 from "../../assets/int24.png";
import int25 from "../../assets/int25.jpeg";
import int26 from "../../assets/int26.jpeg";

const SUBTITLE_TEXT =
  "We plan, build, and design functional, beautiful environments for offices, retail, hospitality, and residential developments across Egypt and the GCC – aligned with Bin Rashid Group's standards for quality, detail, and performance.";

const ConstructionInterior = () => {
  const [lightboxIndex, setLightboxIndex] = useState(null);
  const [subtitleLength, setSubtitleLength] = useState(0);
  const [subtitleStarted, setSubtitleStarted] = useState(false);

  useEffect(() => {
    const start = setTimeout(() => setSubtitleStarted(true), 400);
    return () => clearTimeout(start);
  }, []);

  const interiorImages = [
    int3,
    int4,
    int5,
    int6,
    int7,
    int8,
    int9,
    int10,
    int11,
    int12,
    int13,
    int14,
    int15,
    int16,
    int17,
    int18,
    int19,
    int20,
    int21,
    int22,
    int23,
    int24,
    int25,
    int26,
  ];

  useEffect(() => {
    const sections = document.querySelectorAll(".animate-on-scroll");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    sections.forEach((section) => observer.observe(section));
    return () => sections.forEach((section) => observer.unobserve(section));
  }, []);

  useEffect(() => {
    if (!subtitleStarted) return;
    if (subtitleLength >= SUBTITLE_TEXT.length) return;
    const t = setInterval(() => {
      setSubtitleLength((n) => {
        if (n >= SUBTITLE_TEXT.length) {
          clearInterval(t);
          return n;
        }
        return n + 1;
      });
    }, 35);
    return () => clearInterval(t);
  }, [subtitleStarted, subtitleLength]);

  useEffect(() => {
    if (lightboxIndex == null) return;
    const handleKey = (e) => {
      if (e.key === "Escape") setLightboxIndex(null);
      if (e.key === "ArrowLeft")
        setLightboxIndex((i) =>
          i <= 0 ? interiorImages.length - 1 : i - 1
        );
      if (e.key === "ArrowRight")
        setLightboxIndex((i) =>
          i >= interiorImages.length - 1 ? 0 : i + 1
        );
    };
    document.addEventListener("keydown", handleKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleKey);
      document.body.style.overflow = "";
    };
  }, [lightboxIndex, interiorImages.length]);

  const openLightbox = (index) => setLightboxIndex(index);
  const closeLightbox = () => setLightboxIndex(null);
  const goPrev = () =>
    setLightboxIndex((i) =>
      i <= 0 ? interiorImages.length - 1 : i - 1
    );
  const goNext = () =>
    setLightboxIndex((i) =>
      i >= interiorImages.length - 1 ? 0 : i + 1
    );

  return (
    <div className="construction-page">
      {/* Header Section */}
      <div className="construction-hero">
        <div className="construction-hero-overlay" />
        <div className="construction-hero-content animate-on-scroll">
          <p className="construction-kicker">CONSTRUCTION &amp; INTERIOR DESIGN</p>
          <h1 className="construction-title">
            Spaces That <span>Work</span> <br />
            And <span>Inspire</span>.
          </h1>
          <p className="construction-subtitle">
            {SUBTITLE_TEXT.slice(0, subtitleLength)}
            {subtitleLength < SUBTITLE_TEXT.length && (
              <span className="typewriter-cursor" aria-hidden="true">
                |
              </span>
            )}
          </p>
        </div>
      </div>

      {/* What We Deliver */}
      <section className="services-section animate-on-scroll">
        <h2 className="section-title">WHAT WE BUILD &amp; DESIGN</h2>
        <p className="section-intro">
          A single partner for structural works, finishes, and interiors –
          ensuring every decision serves both aesthetics and long‑term
          operations.
        </p>
        <div className="services-grid">
          <div className="service-card service-card--primary">
            <div className="service-icon">DB</div>
            <h3>Design &amp; Build</h3>
            <p>
              Integrated architectural, structural, and interior design with
              full execution on site – one accountable team from concept to
              handover.
            </p>
          </div>
          <div className="service-card">
            <div className="service-icon">FO</div>
            <h3>Fit‑Out &amp; Joinery</h3>
            <p>
              Turnkey fit‑out, custom joinery, ceilings, flooring, and lighting
              layouts that bring your brand and workflows to life.
            </p>
          </div>
          <div className="service-card">
            <div className="service-icon">RN</div>
            <h3>Renovation &amp; Upgrades</h3>
            <p>
              Transform under‑performing assets into contemporary, efficient
              spaces with phased works that minimize downtime.
            </p>
          </div>
          <div className="service-card">
            <div className="service-icon">PM</div>
            <h3>Project &amp; Cost Management</h3>
            <p>
              Structured timelines, transparent costing, and on‑site supervision
              to keep quality, budget, and safety fully under control.
            </p>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="process-section animate-on-scroll">
        <h2 className="section-title">OUR PROJECT DELIVERY PROCESS</h2>
        <div className="process-steps">
          <div className="step-item">
            <div className="step-number">01</div>
            <h3>DISCOVER &amp; DEFINE</h3>
            <p>
              Site survey, technical due diligence, and briefing workshops to
              capture function, brand, budget, and regulatory needs.
            </p>
          </div>
          <div className="step-item">
            <div className="step-number">02</div>
            <h3>DESIGN &amp; VISUALIZE</h3>
            <p>
              Concept, layouts, 3D mood boards, and material palettes that
              translate your vision into a practical, buildable design.
            </p>
          </div>
          <div className="step-item">
            <div className="step-number">03</div>
            <h3>BUILD &amp; SUPERVISE</h3>
            <p>
              Civil, MEP, and finishing works delivered through vetted
              contractors with our team supervising every milestone.
            </p>
          </div>
          <div className="step-item">
            <div className="step-number">04</div>
            <h3>HANDOVER &amp; SUPPORT</h3>
            <p>
              Snag‑free handover, as‑built documentation, and post‑completion
              support to keep the space performing over time.
            </p>
          </div>
        </div>
      </section>

      {/* Sectors Section */}
      <section className="industries-section animate-on-scroll">
        <h2 className="section-title">SECTORS WE SERVE</h2>
        <div className="industries-grid">
          {[
            "Corporate Offices & Headquarters",
            "Residential Compounds & Villas",
            "Retail Stores & F&B Concepts",
            "Hotels, Resorts & Serviced Apartments",
            "Clinics, Hospitals & Medical Centers",
            "Schools, Universities & Training Facilities",
            "Industrial & Logistics Facilities",
            "Showrooms & Experience Centers",
          ].map((sector, index) => (
            <div key={index} className="industry-tag">
              {sector}
            </div>
          ))}
        </div>
      </section>

      {/* Design Principles */}
      <section className="principles-section animate-on-scroll">
        <h2 className="section-title">OUR DESIGN PRINCIPLES</h2>
        <div className="principles-grid">
          <div className="principle-card">
            <h3>Function First</h3>
            <p>
              Flows, adjacencies, and MEP planning that support how your people,
              customers, and equipment move through the space every day.
            </p>
          </div>
          <div className="principle-card">
            <h3>Brand in Every Detail</h3>
            <p>
              Materials, lighting, and signage chosen to reflect your identity,
              not just generic finishes.
            </p>
          </div>
          <div className="principle-card">
            <h3>Future‑Ready</h3>
            <p>
              Flexible layouts, service routes, and technology provisions that
              allow the space to evolve with your business.
            </p>
          </div>
        </div>
      </section>

      {/* Interior Design Gallery */}
      <section className="gallery-section animate-on-scroll">
        <h2 className="section-title">INTERIOR DESIGN GALLERY</h2>
        <p className="section-intro">
          A selection of interiors delivered by our teams – from clean,
          efficient workspaces to warm, hospitality‑grade environments. Click an
          image to open the gallery and switch between photos.
        </p>
        <div className="gallery-grid">
          {interiorImages.map((src, index) => (
            <figure
              key={index}
              className="gallery-item"
              onClick={() => openLightbox(index)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  openLightbox(index);
                }
              }}
              aria-label={`View interior ${index + 1}`}
            >
              <img src={src} alt={`Interior design ${index + 1}`} />
              <figcaption>Interior #{index + 1}</figcaption>
            </figure>
          ))}
        </div>

        {/* Lightbox */}
        {lightboxIndex !== null && (
          <div
            className="gallery-lightbox"
            onClick={closeLightbox}
            role="dialog"
            aria-modal="true"
            aria-label="Image gallery viewer"
          >
            <button
              type="button"
              className="gallery-lightbox-close"
              onClick={closeLightbox}
              aria-label="Close"
            >
              ×
            </button>
            <button
              type="button"
              className="gallery-lightbox-prev"
              onClick={(e) => {
                e.stopPropagation();
                goPrev();
              }}
              aria-label="Previous image"
            >
              ‹
            </button>
            <button
              type="button"
              className="gallery-lightbox-next"
              onClick={(e) => {
                e.stopPropagation();
                goNext();
              }}
              aria-label="Next image"
            >
              ›
            </button>
            <div
              className="gallery-lightbox-content"
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={interiorImages[lightboxIndex]}
                alt={`Interior design ${lightboxIndex + 1}`}
              />
              <span className="gallery-lightbox-counter">
                {lightboxIndex + 1} / {interiorImages.length}
              </span>
            </div>
          </div>
        )}
      </section>

      {/* Why BRG Section */}
      <section className="why-brg-section animate-on-scroll">
        <h2 className="section-title">WHY BRG FOR CONSTRUCTION &amp; INTERIOR?</h2>
        <div className="why-grid">
          <div className="why-item">
            <h4>One Partner, End‑to‑End</h4>
            <p>
              Strategy, approvals, construction, and interiors delivered under
              one roof, aligned with your wider expansion plans.
            </p>
          </div>
          <div className="why-item">
            <h4>Regional Delivery Experience</h4>
            <p>
              Projects completed across Egypt, KSA, and UAE with deep knowledge
              of local building codes and authorities.
            </p>
          </div>
          <div className="why-item">
            <h4>Cost &amp; Time Transparency</h4>
            <p>
              Clear programmes, cost breakdowns, and progress tracking so there
              are no surprises on site.
            </p>
          </div>
          <div className="why-item">
            <h4>Quality &amp; Safety Culture</h4>
            <p>
              Supplier vetting, method statements, and supervision built around
              safety and long‑term durability.
            </p>
          </div>
          <div className="why-item">
            <h4>Aligned With BRG Services</h4>
            <p>
              Spaces designed to work hand‑in‑hand with your legal, financial,
              and operational structures.
            </p>
          </div>
          <div className="why-item">
            <h4>Post‑Handover Partnership</h4>
            <p>
              We stay involved beyond opening day, advising on tweaks and
              expansions as your footprint grows.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ConstructionInterior;

